let Events = require('f.core.event');
require('./style.scss');
let tmpl = require('./main.ejs');

let Info = function (data, message, isLive, native) {
    this.message = message;
    this.data = $.extend(true, {}, data);
    this.data.showOnlineNum = window.showOnlineNum || false;
    this.data.isApp = native.isApp;
    if (
        native.isApp &&
        (native.getAppName() === 'videoapp' || !grounds.syncSubscribe)
    ) {
        this.data.isApp = 0;
    }
    this.isLive = isLive;
    this.native = native;
    this.init();
};

const formatCount = function (val) {
    if (val < 10000) {
        return val;
    } else {
        return (val / 10000).toFixed(1) + '万';
    }
};

const isBrowser = () => {
    return typeof grounds === 'object' ? false : true;
};

const goToPage = (params = {}) => {
    let _url = null;
    const isFull = 1;
    let _param = null;
    const mode = window.mode || 'day';

    if (isBrowser()) {
        _param = $.param(params);
    } else {
        _param = $.param(
            $.extend(params, { webkit: 1, isFull, mode, immersion: true })
        );
    }

    _url = `https://izhibo.ifeng.com/column.html?${_param}`;

    if (isBrowser()) {
        window.location.href = _url;
    } else {
        grounds.dispatch('web', `${_url}`, '', '', '');
    }
};

Info.prototype.init = function () {
    this.initDom();
    this.initEvent();
};

Info.prototype.initDom = function () {
    this.el = $(tmpl(this.data));
    this.elBtn = $(this.el[0]).find('.c-info__btn');
    this.elIntro = this.el.filter('.c-info__content');
    this.subscribe = this.el[0].querySelector('.c-channel__subscribe');
    this.columnIcon = $(this.el[0]).find('.c-channel__icon');
    this.columnName = $(this.el[0]).find('.c-channel__name');
};

Info.prototype.initEvent = function () {
    let self = this;

    this.message.on('online:info', '201', this.changeCount.bind(this));

    this.el.on('touchend', function () {
        return false;
    });

    if (this.data.isApp) {
        if (this.data.loginid && this.data.loginid !== '') {
            this.checkOrder()
                .then(function (result) {
                    if (result.code === 200) {
                        // 请求成功
                        console.log('登录啦！4444');
                        if (result.data[self.data.followid] === 1) {
                            // 已订阅
                            self.subscribe.classList.add('clicked');
                            self.subscribe.classList.remove('plus');
                            $(self.subscribe).text('已关注');
                        } else {
                            self.follow = false;
                        }
                        self.subscribe.addEventListener(
                            'touchend',
                            function () {
                                if (self.follow) {
                                    // 请求取消订阅接口
                                    self.requestData('cancel').then(function (
                                        result
                                    ) {
                                        if (result.code + '' !== '200') {
                                            return false;
                                        }
                                        self.subscribe.classList.remove(
                                            'clicked'
                                        );
                                        self.subscribe.classList.add('plus');
                                        $(self.subscribe).text('关注');
                                        self.native.syncSubscribe({
                                            followid: self.data.followid,
                                            type: 'zhibo',
                                            isSubscribe: 0
                                        });
                                        self.follow = false;
                                        // 发送统计
                                        self.native.actionStat({
                                            type: 'chsub',
                                            id: 'live_sub_' + self.data.columnId
                                        });
                                    });
                                } else {
                                    // 未订阅请求用户订阅接口
                                    self.requestData('add').then(function (
                                        result
                                    ) {
                                        if (result.code + '' !== '200') {
                                            return false;
                                        }
                                        self.subscribe.classList.add('clicked');
                                        self.subscribe.classList.remove('plus');
                                        $(self.subscribe).text('已关注');
                                        self.native.syncSubscribe({
                                            followid: self.data.followid,
                                            type: 'zhibo',
                                            isSubscribe: 1
                                        });
                                        self.follow = true;
                                        // 发送统计
                                        self.native.actionStat({
                                            type: 'chunsub',
                                            id: 'live_sub_' + self.data.columnId
                                        });
                                    });
                                }
                            }
                        );
                    }
                })
                .catch(function (e) {
                    console.log(e, 'adffgdfgfg');
                    self.subscribe.addEventListener('touchend', function () {
                        // 拉起登录
                        self.trigger('login');
                    });
                });
        } else {
            self.subscribe.addEventListener('touchend', function () {
                // 拉起登录

                self.trigger('login');
            });
        }
    }

    this.elBtn.on(
        'touchend',
        function () {
            if (this.elBtn.hasClass('selected')) {
                this.introHide();
            } else {
                this.introShow();
            }
            return false;
        }.bind(this)
    );

    // 点击栏目头像或者栏目名称跳转
    this.columnIcon.on('touchend', () => {
        goToPage({ id: this.data.columnId, refer: '' });
    });

    this.columnName.on('touchend', () => {
        goToPage({ id: this.data.columnId, refer: '' });
    });
};

Info.prototype.changeCount = function (msg) {
    if (msg.code === 1) {
        this.el.find('.c-visite span').text(formatCount(msg.number));
    }
};

Info.prototype.introShow = function () {
    this.elBtn.addClass('selected');
    this.elIntro.slideDown(
        300,
        function () {
            this.trigger('toggle');
        }.bind(this)
    );
};

Info.prototype.introHide = function () {
    this.elBtn.removeClass('selected');
    this.elIntro.slideUp(
        300,
        function () {
            this.trigger('toggle');
        }.bind(this)
    );
};

Info.prototype.renderTo = function (parentNode) {
    $(parentNode).append(this.el);
};

Info.prototype.checkOrder = function () {
    // 请求订阅接口查看是否订阅
    let loginid = this.data.loginid;
    let followid = this.data.followid;
    let token = this.data.token;
    let guid = this.data.loginid;
    let deviceid = this.native.getDeviceInfo().getDeviceId();
    let os = this.native.getDeviceInfo().getOs();
    let data = {
        loginid: loginid,
        followids: followid + '',
        token: token,
        os: os,
        guid: guid,
        deviceid: deviceid
    };
    let promise = Promise.resolve(
        $.ajax({
            url: this.data.queryFollow,
            type: 'GET',
            data: data,
            cache: true,
            dataType: 'jsonp'
        })
    ); // => promise对象
    return promise;
};

Info.prototype.requestData = function (type) {
    let self = this;

    // 查询是否关注 http://10.21.6.38/Social_Api_Fans/relation?loginid=71614570&followids=zhibo_liveid 返回值为0表示未关注
    // 如果未关注 则点击订阅后请求 用户关注接口 http://10.21.6.38/Social_Api_Follow/add?loginid=72851320&followid=user_2423&token=afd2534as46534fd
    // 如果已关注 则点击订阅后 请求取消关注接口 http://10.21.6.38/Social_Api_Follow/cancel?loginid=72851320&followid=user_2423&token=234234sdfasdf
    let loginid = this.data.loginid;
    let followid = this.data.followid;
    let token = this.data.token;
    let guid = this.data.loginid;
    let deviceid = this.native.getDeviceInfo().getDeviceId();
    let os = this.native.getDeviceInfo().getOs();
    let data = {
        loginid: loginid,
        followid: followid,
        token: token,
        os: os,
        guid: guid,
        deviceid: deviceid
    };
    let promise = Promise.resolve(
        $.ajax({
            url: self.data.followUrl + type,
            type: 'GET',
            data: data,
            cache: true,
            dataType: 'jsonp'
        })
    );
    return promise;
};

Events.mixTo(Info);
module.exports = Info;



// WEBPACK FOOTER //
// ./app/modules/info/index.js